<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title title">Edit Login Details</p>
    </header>
      <section class="modal-card-body">
        <p class="successful">Details updated successfully</p>
        <svg width="46" height="36" viewBox="0 0 46 36" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M44.3953 0.449951L14.7093 26.5255L1.60465 17.0313L0 18.5691L14.7093 35.9529L46 1.98774L44.3953 0.449951Z" fill="#5051DB"/>
        </svg>
        <p>Back to <a href="/"> Dashboard</a></p>
      </section>
    </div>
</template>

<script>
export default {
  name: 'PasswordResetSuccess'
};
</script>

<style scoped>
.modal-card {
  width: 30vw !important;
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
  color: #000000;
}
.modal-card-body {
    text-align: center;
}
.successful {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: -0.4px;
    color: #817F7F;
    margin-bottom: 30px;

}
svg {
    margin-bottom: 30px;
}
@media screen and (max-width: 768px) {
  .modal-card {
    width: 90vw !important;
  }
}
</style>
